var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { AlertDialog, AlertDialogBody, AlertDialogFooter, AlertDialogHeader, AlertDialogContent, AlertDialogOverlay, Button, Box, } from "@chakra-ui/react";
import { observer } from 'mobx-react';
import { StoreContext } from '@/app/uistore/Rootstore';
let LetrwingAlertDialog = class LetrwingAlertDialog extends React.Component {
    constructor() {
        super(...arguments);
        this.cancelRef = React.createRef();
    }
    close() {
        const rstore = this.context;
        rstore.aletrDialogStore.setOpen(false);
    }
    render() {
        const rstore = this.context;
        return (React.createElement(AlertDialog, { isOpen: rstore.aletrDialogStore.open, leastDestructiveRef: this.cancelRef, onClose: () => this.close() },
            React.createElement(AlertDialogOverlay, { zIndex: 100000000 },
                React.createElement(AlertDialogContent, { zIndex: 100000000 },
                    React.createElement(Box, null,
                        React.createElement(AlertDialogHeader, { fontSize: "lg", fontWeight: "bold" }, "Alert"),
                        React.createElement(AlertDialogBody, null, rstore.aletrDialogStore.message),
                        React.createElement(AlertDialogFooter, null,
                            React.createElement(Button, { ref: this.cancelRef, onClick: () => this.close() }, "OK")))))));
    }
};
LetrwingAlertDialog.contextType = StoreContext;
LetrwingAlertDialog = __decorate([
    observer
], LetrwingAlertDialog);
export { LetrwingAlertDialog };
